import { createElement, forwardRef } from 'react';
import { useDesignTokens, renderInlineCssVars } from '../../theme';
import { useTruncationTooltip } from '../../hooks/useTruncationTooltip';
import { LinkProps } from './types';
import cx from 'classnames';
import cn from './Link.css.json';
import './Link.css';

export const Link = forwardRef<HTMLAnchorElement, LinkProps>(function Link(props, ref) {
  const setRef = useTruncationTooltip(ref);
  const {
    children,
    small,
    disabled,
    wrapText,
    className,
    style,
    tabIndex,
    decoration,
    href,
    onPress,
    testId,
    ...restProps
  } = props;

  const dt = useDesignTokens();
  const tokens = renderInlineCssVars(
    {
      fg: disabled ? dt.stateStandardNova.disabled.fg : dt.stateStandardNova.normal.fg,
      'font-size-m': dt.fontNova.size.m,
      'font-size-s': dt.fontNova.size.s,
    },
    'link'
  );
  return (
    <a
      {...restProps}
      data-testid={testId}
      // Do not use the truncationTooltip ref if the consumer has set the title explicitlyS
      ref={wrapText === false && !props.title ? setRef : ref}
      className={cx(
        cn.link,
        className,
        wrapText === false && cn.nowrap,
        small && cn.small,
        disabled && cn.disabled,
        decoration === 'hover-only' && cn.decoration.hover
      )}
      style={{ ...tokens, ...style }}
      href={href && !disabled ? href : undefined}
      tabIndex={tabIndex ?? 0}
      onClick={(e) => {
        if (onPress) e.preventDefault();
        if (disabled) return;
        onPress?.(e);
      }}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          if (disabled) return;
          if (href) {
            e.stopPropagation();
            return;
          }
          e.preventDefault();
          onPress?.(e);
        }
        props.onKeyDown?.(e);
      }}
    >
      <span className={cn.text}>{children}</span>
    </a>
  );
});
